import { ChevronLeft } from 'lucide-react';
import { BACK_BTN, PRIMARY_BTN, SECONDARY_BTN, getIntroCopy } from './helper';

const Intro = ({ attributes, onAdd, onSelfPay, onCancel = null, isSubmitting = false, disabled = false }) => {
  const { icon: ActionIcon, title, description, action } = getIntroCopy(attributes);
  const isSelfPay = attributes?.active === false;
  // `disabled` holds the actions without claiming a submit is in flight, so the
  // self-pay button below keeps its spinner tied to isSubmitting alone.
  const blocked = isSubmitting || disabled;

  return (
    <div className={`relative flex flex-col items-center rounded-2xl border border-gray-200 bg-white px-6 pb-10 text-center ${onCancel ? 'pt-14' : 'pt-10'}`}>
      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          disabled={blocked}
          aria-label="Back"
          className={`${BACK_BTN} absolute left-4 top-4`}
        >
          <ChevronLeft size={16} strokeWidth={2.5} />
        </button>
      )}

      <p className="text-base font-bold text-secondary-900">{title}</p>
      <p className="mt-1 max-w-sm text-sm text-secondary-500">{description}</p>

      <div className="mt-5 flex w-full flex-col gap-2.5 sm:w-auto sm:flex-row">
        <button type="button" onClick={onAdd} disabled={blocked} className={PRIMARY_BTN}>
          <ActionIcon size={15} strokeWidth={2.5} />
          {action}
        </button>

        {!isSelfPay && (
          <button type="button" onClick={onSelfPay} disabled={blocked} className={SECONDARY_BTN}>
            {isSubmitting ? <span className="loading loading-spinner loading-sm" /> : 'Mark as self-pay'}
          </button>
        )}
      </div>
    </div>
  );
};

export default Intro;
